import React, {useContext, useState} from 'react';
import {useIntl} from 'react-intl';
import {ModalBody, ModalHeader} from 'reactstrap';
import styled from 'styled-components';
import {ThemeContext} from '../../../apiContexts';
import RoundButton from '../../../components/roundButton';
import CommandContainer from '../../../containers/command-container';
import {ModalStyled} from '../../../styles';
import {colors} from '../../../styleVariables';

const Style = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: white;

  * {
    opacity: 1;
  }

  > strong {
    display: flex;
    justify-content: center;
    font-size: 0.8rem !important;
    color: ${(props) => props.theme};
  }

  .badge {
    color: ${colors.gray};
    font-size: 0.8rem !important;
  }
`;

const Actions = ({trace, traceToggle, followToogle, follow, createGeofence}) => {
  const theme = useContext(ThemeContext);
  const intl = useIntl();
  const [modal, setModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({title: 'Título', type: ''});

  const toggle = () => setModal(!modal);

  const openSendCommand = () => {
    setModalInfo({
      title: intl.formatMessage({id: 'commandTitle'}),
      type: 'group',
    });
    toggle();
  };

  return (
    <Style theme={theme} id="deviceActions">
      <strong>Ações para o Dispositivo</strong>
      <div className="mt-2 d-flex justify-content-between">
        <RoundButton
          withBorder
          noBgBadge
          labelDirection="bottom"
          label="Rota"
          active={trace}
          onClick={traceToggle}
        >
          <span className="fal fa-route" />
        </RoundButton>

        <RoundButton
          withBorder
          noBgBadge
          labelDirection="bottom"
          label={intl.formatMessage({id: 'commandTitle'})}
          onClick={() => openSendCommand()}
        >
          <span className="fal fa-upload" />
        </RoundButton>

        <RoundButton
          withBorder
          noBgBadge
          labelDirection="bottom"
          label="Seguir"
          active={follow}
          onClick={followToogle}
        >
          <span className="fas fa-location-arrow" />
        </RoundButton>

        <RoundButton
          withBorder
          noBgBadge
          labelDirection="bottom"
          onClick={createGeofence}
          label="Cerca">
          <span
            style={{fontSize: '2rem'}}
            className="fal fa-location-circle fa-2x"
          />
        </RoundButton>

        <ModalStyled
          theme={theme}
          size="sm"
          centered
          unmountOnClose
          className={`customModal`}
          isOpen={modal}
          toggle={toggle}
        >
          <ModalHeader toggle={toggle}>{modalInfo.title}</ModalHeader>
          <ModalBody>
            <CommandContainer toggle={toggle} />
          </ModalBody>
        </ModalStyled>
      </div>
    </Style>
  );
};

export default Actions;
